//react
import injectSheet from "react-jss";
import {useEffect, useState} from "react";

//styles
import styles from "./draggablelist_styles";
import { DragDropContext,Droppable,Draggable } from 'react-beautiful-dnd';

import DraggableListItem from "./draggablelistitem/draggablelistitem";


/**************************************** REPORT BUILDER DRAGGABLE COMPONENT ******************************************** */
const DraggableList = injectSheet(styles)((props) => {

    const {field, formValues, skipValidation, errorMessage, options , handleOrderChange  ,handleOnRemoval , handleOnChange, klass} = props;
    const listItems = formValues[field] || [];
    let [displayedItems, setDisplayedItems] = useState([]);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(listItems);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setDisplayedItems(items);
        handleOrderChange({[field]: items});
    }

    const handleDeletion = (item) => {
         const items = displayedItems.filter((o) => o.value !== item.value);
         handleOnRemoval({[field]: [item.value]} , items)
    }

    useEffect(() => {
        if(listItems && listItems.length) {
            setDisplayedItems(listItems.map(el => options.find(item => item.value === el)));
        } else {
            setDisplayedItems([]);
        }
    }, [listItems])

    return (
        <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId='items'>
                {(provided) => (

                <div className={`draggable sortablelist ${props.classes.draggableList} items ${klass}`} {...provided.droppableProps} ref={provided.innerRef}>
                    {displayedItems.map(((item, index) =>
                    {
                        if (!item || !item.text) {
                            return null;
                        }
                        return (
                            <Draggable id={index} draggableId={index.toString()} index={index} key={index.toString()}>
                                {(provided) => (
                                    item && item.text && <DraggableListItem
                                        label={item.text}
                                        innerRef={provided.innerRef}
                                        provided={provided}
                                        handleDeletion={handleDeletion}
                                        item={item}
                                    ></DraggableListItem>
                                )}
                            </Draggable>
                        )
                    }

                    ))}
                    {provided.placeholder}
                </div>
                )}
            </Droppable>

        </DragDropContext>
    )
});

export default DraggableList;